import PropTypes from 'prop-types';
export const sectionContent = PropTypes.shape({
	sectionId: PropTypes.string,
	sectionNum: PropTypes.string,
	translation: PropTypes.string,
	transcript: PropTypes.string,
	coordinates: PropTypes.shape({
		x: PropTypes.number,
		y: PropTypes.number,
		width: PropTypes.number,
		height: PropTypes.number,
	}),
	relatedArt: PropTypes.arrayOf(
		PropTypes.shape({
			copy: PropTypes.string,
			footNum: PropTypes.string,
			image: PropTypes.string,
			link: PropTypes.string,
			title: PropTypes.string,
			year: PropTypes.string,
		})
	),
	colorNotes: PropTypes.shape({
		coordinates: PropTypes.shape({
			x: PropTypes.number,
			y: PropTypes.number,
			width: PropTypes.number,
			height: PropTypes.number,
		}),
		id: PropTypes.string,
		transcriptionColorNotes: PropTypes.shape({
			alt: PropTypes.string,
			image: PropTypes.string,
		}),
		translationColorNotes: PropTypes.shape({
			alt: PropTypes.string,
			image: PropTypes.string,
		}),
	}),
});
export const menuProps = {
	shown: PropTypes.string,
	currentView: PropTypes.string,
	updateSidebar: PropTypes.func,
	content: PropTypes.shape({
		uid: PropTypes.number,
		tiles: PropTypes.string,
		thumbnail: PropTypes.string,
		left: PropTypes.shape({
			side: PropTypes.string,
			title: PropTypes.string,
			sections: PropTypes.arrayOf(sectionContent),
		}),
		right: PropTypes.shape({
			side: PropTypes.string,
			title: PropTypes.string,
			sections: PropTypes.arrayOf(sectionContent),
		}),
	}),
};
export const pageProps = {
	position: PropTypes.string,
	shwn: PropTypes.string,
	currentView: PropTypes.string,
	pageContent: PropTypes.array,
	title: PropTypes.string,
	folioSide: PropTypes.string,
	highlightedSection: PropTypes.string,
	reverseContent: PropTypes.func,
	currentFootnotes: PropTypes.object,
	updateFootnote: PropTypes.func,
	toggleDrawer: PropTypes.func,
	showAllFootnotes: PropTypes.func,
};
export const sectionProps = {
	currentView: PropTypes.string,
	highlightedSection: PropTypes.string,
	id: PropTypes.string,
	currentFootnotes: PropTypes.object,
	updateFootnote: PropTypes.func,
	toggleDrawer: PropTypes.func,
	showAllFootnotes: PropTypes.func,
	sectionContent,
};
export const zoomSliderProps = {
	updateZoomLevel: PropTypes.func,
	setZoomLevelState: PropTypes.func,
	currentZoom: PropTypes.number,
	maxZoom: PropTypes.number,
	minZoom: PropTypes.number,
};
export const notebookViewerProps = {
	viewerType: PropTypes.string,
	currentView: PropTypes.string,
	left: PropTypes.shape({
		side: PropTypes.string,
		title: PropTypes.string,
		sections: PropTypes.arrayOf(sectionContent),
	}),
	right: PropTypes.shape({
		side: PropTypes.string,
		title: PropTypes.string,
		sections: PropTypes.arrayOf(sectionContent),
	}),
	tilePrefix: PropTypes.string,
	folioNum: PropTypes.number,
};

export const seaDragonProps = {
	currentView: PropTypes.string,
	leftSections: PropTypes.arrayOf(
		PropTypes.shape({
			sectionContent,
		})
	),
	rightSections: PropTypes.arrayOf(
		PropTypes.shape({
			sectionContent,
		})
	),
	leftColorNotes: PropTypes.array,
	tiles: PropTypes.string,
	highlightedSection: PropTypes.string,
	highlightSection: PropTypes.func,
	setZoomLevelState: PropTypes.func,
};
export const paginatorProps = {
	viewerType: PropTypes.string,
	paginatorOpen: PropTypes.string,
	setPaginatorState: PropTypes.func,
	tiles: PropTypes.string,
	totalPages: PropTypes.number,
};

export const prevNextProps = {
	currentView: PropTypes.string,
	viewerType: PropTypes.string,
	paginatorOpen: PropTypes.string,
	setPaginatorState: PropTypes.func,
	totalPages: PropTypes.number,
};

export const flyoutOutProps = {
	content: PropTypes.obj,
};

export const nextPrevBtnProps = {
	paginatorOpen: PropTypes.string,
	currentView: PropTypes.string,
};
